import { useFormContext } from "react-hook-form";
import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { useEffect } from "react";
import { VRSTA_OPERATERA } from "../../../../enums";
import { PorukaGreskePolja } from "../../../index";

const Index = () => {
  const { register, getValues, setValue, watch } = useFormContext();
  const prirodaObvezeIzvjescivanja = getValues("prirodaObvezeIzvjescivanja.id");
  const vrstaOperatera = getValues("operaterPlatforme.vrstaOperatera.id");
  const obvezeIzvjescivanja = getValues("obvezeIzvjescivanja");

  const watchField = watch([
    "prirodaObvezeIzvjescivanja.id",
    "prirodaObvezeIzvjescivanja.opis",
  ]);

  useEffect(() => {
    if (parseInt(vrstaOperatera) !== VRSTA_OPERATERA.IZVAN_EU) {
      setValue("prirodaObvezeIzvjescivanja", null);
    }
  }, [watchField]);

  if (parseInt(vrstaOperatera) !== VRSTA_OPERATERA.IZVAN_EU) return null;

  return (
    <>
      <Grid item xs={12} sx={{ mt: 3 }}>
        <FormControl fullWidth>
          <InputLabel id="prirodaObvezeIzvjescivanja.id">
            *Priroda obveze izvješćivanja (Nature of reporting obligation)
          </InputLabel>
          <Select
            labelId="prirodaObvezeIzvjescivanja.id"
            id="prirodaObvezeIzvjescivanja.id"
            value={
              prirodaObvezeIzvjescivanja !== undefined
                ? prirodaObvezeIzvjescivanja
                : ""
            }
            label="*Priroda obveze izvješćivanja (Nature of reporting obligation)"
            variant={"standard"}
            {...register("prirodaObvezeIzvjescivanja.id")}
            onChange={(e: SelectChangeEvent<any>) =>
              setValue("prirodaObvezeIzvjescivanja.id", e.target.value)
            }
          >
            {obvezeIzvjescivanja.map(
              (obvezaIzvjescivanja: any, key: number) => (
                <MenuItem key={key} value={obvezaIzvjescivanja.id}>
                  {obvezaIzvjescivanja.id}
                </MenuItem>
              )
            )}
          </Select>
          <PorukaGreskePolja nazivPolja={"prirodaObvezeIzvjescivanja"} />
        </FormControl>
      </Grid>
    </>
  );
};

export default Index;
